export enum RewriterLengthEnum {
  Shorter = 'shorter',
  AsIs = 'as-is',
  Longer = 'longer'
}
